module.exports = __webpack_public_path__ + "aaaf51eb123881ce2c851a88b4065dd2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/new-realisations/xyz/lao/02.jpg
// module id = rhiI
// module chunks = 0